'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UICardHeader = require('./UICardHeader');

var _UICardHeader2 = _interopRequireDefault(_UICardHeader);

var _UICardSection = require('./UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _UIDragHandle = require('../draggable/UIDragHandle');

var _UIDragHandle2 = _interopRequireDefault(_UIDragHandle);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _CSSHeightTransition = require('../animation/CSSHeightTransition');

var _CSSHeightTransition2 = _interopRequireDefault(_CSSHeightTransition);

var _times = require('HubStyleTokens/times');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TRANSITION_ANIMATION_TIMEOUT = parseInt(_times.CARD_TRANSITION_ANIMATION_TIMING, 10);

var isDraggable = function isDraggable(child) {
  return child.type.displayName === _UIDragHandle2.default.displayName;
};

var UICardWrapper = _react2.default.createClass({
  displayName: 'UICardWrapper',

  propTypes: _extends({}, _UISection2.default.propTypes, {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    compact: _react.PropTypes.bool.isRequired,
    expanded: _react.PropTypes.bool,
    expandable: _react.PropTypes.bool,
    onExpandedChange: _react.PropTypes.func
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UISection2.default.defaultProps, {
      compact: false,
      expandable: false,
      expanded: true
    });
  },
  cloneHeader: function cloneHeader(child) {
    var _props = this.props,
        expanded = _props.expanded,
        onExpandChange = _props.onExpandedChange;

    var props = isDraggable(child) ? { childProps: { expanded: expanded, onExpandChange: onExpandChange } } : { expanded: expanded, onExpandChange: onExpandChange };

    return _react2.default.cloneElement(child, props);
  },
  isExpander: function isExpander(child) {
    if (_react2.default.isValidElement(child) && isDraggable(child)) {
      child = child.props.children;
    }

    return _react2.default.isValidElement(child) && child.type === _UICardHeader2.default;
  },
  isSection: function isSection(child) {
    return _react2.default.isValidElement(child) && child.type === _UICardSection2.default;
  },
  renderExpandingContent: function renderExpandingContent(expanded, child) {
    if (!child) return null;

    return _react2.default.createElement(
      _CSSHeightTransition2.default,
      {
        className: 'private-card__height-transition private-card__content-wrapper',
        open: expanded,
        animationTiming: TRANSITION_ANIMATION_TIMEOUT
      },
      child
    );
  },
  renderChildren: function renderChildren(_ref) {
    var _this = this;

    var children = _ref.children,
        expandable = _ref.expandable,
        expanded = _ref.expanded;

    if (!expandable) return children;

    var sawHeader = false;
    var output = _react.Children.map(children, function (child) {
      if (_this.isExpander(child)) {
        sawHeader = true;
        return _this.cloneHeader(child);
      }

      if (_this.isSection(child)) {
        return _this.renderExpandingContent(expanded, child);
      }

      return child;
    });

    if (!sawHeader) {
      var msg = 'UICardHeader: expandable behavior requires UICardHeader child';
      _devLogger2.default.warn({ message: msg, key: msg });
    }

    return output;
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        className = _props2.className,
        compact = _props2.compact,
        expandable = _props2.expandable,
        expanded = _props2.expanded,
        __onExpandedChange = _props2.onExpandedChange,
        rest = _objectWithoutProperties(_props2, ['children', 'className', 'compact', 'expandable', 'expanded', 'onExpandedChange']);

    return _react2.default.createElement(
      _UISection2.default,
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-card', 'private-card__wrapper', {
          'private-card--compact': compact
        }, className)
      }),
      this.renderChildren({ children: children, expandable: expandable, expanded: expanded })
    );
  }
});

exports.default = (0, _Controllable2.default)(UICardWrapper, ['expanded']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/card/UICardWrapper.js
// module id = 430
// module chunks = 0